import { DeserializeOptions } from '@lumapps/wrex/serialization/markdown/fromMarkdown/types';

import { createCodeBlock } from '../../utils/createCodeBlock';

export const CODE_BLOCK_ELEMENTS: DeserializeOptions['elements'] = {
    code: {
        convert: (node) => createCodeBlock([{ text: node.value }]),
    },
};
